import { render, staticRenderFns } from "./SectorsTree.vue?vue&type=template&id=7229cb7c&scoped=true&"
import script from "./SectorsTree.vue?vue&type=script&lang=js&"
export * from "./SectorsTree.vue?vue&type=script&lang=js&"
import style0 from "./SectorsTree.vue?vue&type=style&index=0&id=7229cb7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7229cb7c",
  null
  
)

export default component.exports